import { gql } from '@apollo/client';

// 研发工具：按「国家区号 + 手机号」直接发送短信（后端 SmsToolMutation.sendSmsByPhone）
export const SEND_SMS_BY_PHONE = gql`
  mutation SendSmsByPhone($input: SendSmsByPhoneInput!) {
    sendSmsByPhone(input: $input) {
      success
      messageId
      errorMessage
    }
  }
`;

export interface SendSmsByPhoneInput {
  countryCode: number;
  phone: string;
  message: string;
}

export interface SendSmsByPhoneResult {
  success: boolean;
  messageId?: string | null;
  errorMessage?: string | null;
}
